import React from 'react';
import { Link } from 'react-router-dom';

const Cover404 = () => {
  document.title = 'Page Not Found | HYROC';
  return (
    <div className='hy-status-page'>
      <div className='hy-status-card'>
        <div className='hy-status-icon'>
          <i className='ri-compass-3-line' aria-hidden='true'></i>
        </div>
        <div className='hy-status-code'>Error 404</div>
        <h1 className='hy-status-title'>Page not found</h1>
        <p className='hy-status-text'>
          The page you are looking for doesn&apos;t exist or may have been
          moved.
        </p>
        <Link to='/dashboard' className='btn btn-primary px-4'>
          <i className='ri-home-4-line me-2 align-middle'></i>Back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default Cover404;
